import styled from "styled-components";

export const OrderContainerSection = styled.div`
  width: 100%;
  height: 500px;
  background: ${({theme}) => theme.itemBg};
`;
